"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { motion, AnimatePresence } from "motion/react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CMSLink } from "@/components/Link";
import { Media } from "@/components/Media";
export const PortfolioBlock = t0 => {
  const $ = _c(34);
  const {
    works,
    theme
  } = t0;
  const [selectedCategory, setSelectedCategory] = useState("all");
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== selectedCategory || $[1] !== theme || $[2] !== works) {
    const categories = works.reduce(_temp, ["all"]);
    let t8;
    if ($[12] !== selectedCategory) {
      t8 = work_0 => selectedCategory === "all" ? true : work_0.category === selectedCategory;
      $[12] = selectedCategory;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    const filteredWorks = works.filter(t8);
    t6 = theme;
    t7 = "bg-background py-20";
    t4 = "container mx-auto px-4";
    let t9;
    if ($[14] !== selectedCategory) {
      t9 = category => <Button key={category} variant={selectedCategory === category ? "secondary" : "default"} onClick={() => setSelectedCategory(category)} className="text-sm capitalize">{category}</Button>;
      $[14] = selectedCategory;
      $[15] = t9;
    } else {
      t9 = $[15];
    }
    const t10 = categories.map(t9);
    if ($[16] !== t10) {
      t5 = <div className="mb-12 flex flex-wrap justify-center gap-4">{t10}</div>;
      $[16] = t10;
      $[17] = t5;
    } else {
      t5 = $[17];
    }
    T1 = motion.div;
    t2 = true;
    t3 = "grid gap-8 sm:grid-cols-2 lg:grid-cols-3";
    T0 = AnimatePresence;
    t1 = filteredWorks.map(_temp3);
    $[0] = selectedCategory;
    $[1] = theme;
    $[2] = works;
    $[3] = T0;
    $[4] = T1;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    T0 = $[3];
    T1 = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[18] !== T0 || $[19] !== t1) {
    t8 = <T0>{t1}</T0>;
    $[18] = T0;
    $[19] = t1;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== T1 || $[22] !== t2 || $[23] !== t3 || $[24] !== t8) {
    t9 = <T1 layout={t2} className={t3}>{t8}</T1>;
    $[21] = T1;
    $[22] = t2;
    $[23] = t3;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t4 || $[27] !== t5 || $[28] !== t9) {
    t10 = <div className={t4}>{t5}{t9}</div>;
    $[26] = t4;
    $[27] = t5;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== t10 || $[31] !== t6 || $[32] !== t7) {
    t11 = <section data-theme={t6} className={t7}>{t10}</section>;
    $[30] = t10;
    $[31] = t6;
    $[32] = t7;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  return t11;
};
function _temp(acc, work) {
  if (!acc.includes(work?.category)) {
    return [...acc, work.category];
  }
  return acc;
}
function _temp2(link, i) {
  return <CMSLink key={i} {...link.link} className="flex items-center gap-2">{link?.link?.fiIcon && <i className={`mt-[6px] fi ${link?.link?.fiIcon}`} />}</CMSLink>;
}
function _temp3(work_1) {
  return <motion.div key={work_1.id} layout={true} initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }}><Card className="overflow-hidden bg-card"><CardContent className="p-0"><div className="group relative"><Media resource={work_1.image} imgClassName="w-full transition-transform duration-500 group-hover:scale-105" /><div className="absolute inset-0 flex flex-col items-center justify-center bg-black/60 opacity-0 transition-opacity duration-300 group-hover:opacity-100"><h3 className="text-xl font-semibold text-primary">{work_1.title}</h3><p className="text-sm !text-white p-2">{work_1.description}</p>{work_1.enableLink && work_1.links && work_1.links.map(_temp2)}</div></div></CardContent></Card></motion.div>;
}